import * as types from "../actions/actionTypes";
import initialState from "./initialState.js";

export default function userDataReducer(state = initialState.userData, action) {
    const newState = { ...state };
    switch (action.type) {
        case types.LOAD_USERS_DATA_SUCCESS:
            newState.usersData = action.usersData.data.result;
            return newState;
        case types.LOAD_ACTIVE_INACTIVE_USERS_DATA_SUCCESS:
            newState.usersActiveInactiveData = action.activeInactiveUsersData.data.result;
            return newState;
        case types.LOAD_LOGGED_USER_SUCCESS:
            newState.loggedUserDetail = action.loggedUserDetail;
            return newState;
        case types.LOAD_AUTH_PROVIDER_SUCCESS:
            newState.authProvider = action.authProvider;
            return newState;
        default:
            return state;
    }
}
